import { useEffect, useState } from "react";
import Box from "../../components/Box";
import ProductPricingTable from "../../components/ProductPricingTable";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { setProductVariants } from "../../designer/store/slices/productSlice";

const SetPricingRule = ({ pricingData, setPricingData }: any) => {
  // const [pricingRule, setPricingRule] = useState<any>(
  //   productMock.availablePricingRules
  // );
  // const [shippingModel, setShippingModel] = useState<any>(
  //   productMock.availableShippingModels
  // );
  const dispatch = useAppDispatch();
  const [includeShipping, setIncludeShipping] = useState<any>(true);
  const [marginType, setMarginType] = useState<any>("%");
  const [marginValue, setMarginValue] = useState<any>(0);
  // const [pricingData, setPricingData] = useState<any>(pricingTableData);

  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [checkedAll, setCheckedAll] = useState<any>(false);

  // const deleteRule = (tag: string) => {
  //   setPricingRule((prev: any) => prev.filter((item: any) => item !== tag));
  // };

  // const deleteModel = (tag: string) => {
  //   setShippingModel((prev: any) => prev.filter((item: any) => item !== tag));
  // };

  // const addRule = (e: any) => {
  //   if (e.target.value && !pricingRule.includes(e.target.value)) {
  //     setPricingRule((prev: any) => [...prev, e.target.value]);
  //   }
  // };

  // const addModel = (e: any) => {
  //   if (e.target.value && !shippingModel.includes(e.target.value)) {
  //     setShippingModel((prev: any) => [...prev, e.target.value]);
  //   }
  // };

  const handleIncludeShipping = (val: any) => {
    setIncludeShipping(val);
  };

  const handleMargin = (type: any, val: any) => {
    setMarginType(type);
    setMarginValue(+val);
    if (marginType === "%") {
      setMarginValue(+val / 100);
    }
  };

  const handleRetailPriceChange = (e: any, variant: string) => {
    setPricingData((prevValue: any) =>
      [...prevValue].map((el) =>
        el.variant === variant ? { ...el, retail: +e.target.value } : el
      )
    );
  };

  const handleCheckbox = (id: any) => {
    let newSelectedItems = [];

    if (selectedItems.includes(id)) {
      newSelectedItems = selectedItems.filter((i: any) => i !== id);
    } else {
      newSelectedItems = [...selectedItems, id];
    }

    setSelectedItems(newSelectedItems);
  };

  const handleCheckAll = () => {
    setCheckedAll(!checkedAll);
    if (!checkedAll) {
      setSelectedItems(pricingData.map((i: any) => i["variant"]));
    } else {
      setSelectedItems([]);
    }
  };

  const headers = includeShipping
    ? [
        "Variant",
        "Product Cost",
        "Shipping Cost",
        "Retail Price",
        "Estimated Profit",
      ]
    : ["Variant", "Product Cost", "Retail Price", "Estimated Profit"];

  // useEffect(()=>{
  //   if(productVarinat && productVarinat.length>0){
  //     let newArray:any=[]
  //     productVarinat.forEach((ft:any) => {
  //       newArray.push({
  //         variant: ft.title,
  //         cost: parseFloat(ft.price),
  //         shipping: 2.0,
  //         retail: 29.95,})
  //         });
  //       setPricingData(newArray)
  // }
  // },[])
  const productOption2: any = useAppSelector(
    (state: any) => state.product.product_colors.catalogproductvariants
  );
  const selected_variant_data = useAppSelector(
    (state: any) => state.product.selected_variant_data
  );



  const handleDataChange = async(variants:any)=>{
    const updated_selected_variant = variants.map((variant:any) => {
  const pricingEntry = pricingData.find(
    (price:any) => price.variant === variant.title
  );

  if (pricingEntry) {
    return {
      ...variant,
      cost:parseFloat(pricingEntry.price),
      price: parseFloat(pricingEntry.retail), 
    };
  }

  return variant;
});

console.log("updated_selected_variant___price" , updated_selected_variant);

dispatch(setProductVariants(updated_selected_variant));
    
  }

  useEffect(()=>{
    let variants;
    if(selected_variant_data && selected_variant_data.length==0){
      variants=[productOption2[0]];
      dispatch(setProductVariants(variants));
    }
    else{
      variants=selected_variant_data;
    }
    
    handleDataChange(variants);
    
  },[pricingData])
  

  const PricingTableRow = (rowItem: any, index: number) => {
    return (
      <tr className="border-b border-gray-100" key={index}>
        <td className="p-4">
          <input
            className="w-4 h-4"
            type="checkbox"
            name=""
            id=""
            onChange={() => handleCheckbox(rowItem.variant)}
            checked={selectedItems.includes(rowItem.variant)}
          />
        </td>
        <td className="px-4 uppercase">{rowItem.variant}</td>
        <td className="px-4">${parseFloat(rowItem.price).toFixed(2)}</td>
        {includeShipping && <td className="px-4">$2.00</td>}
        <td className="px-4">
          <div className="flex w-full max-w-[120px] px-3 py-2 bg-gray-50 focus:bg-white rounded-md border border-gray-300">
            <span>$</span>
            <input
              className="inline w-full bg-transparent"
              type="number"
              defaultValue={parseFloat(rowItem.retail).toFixed(2)}
              onChange={(e) => handleRetailPriceChange(e, rowItem.variant)}
            />
          </div>
        </td>
        <td className="px-4 text-[#0C8512]">
          $
          {marginType === "%" &&
            (includeShipping
              ? (parseFloat(rowItem.retail) - 2.0 - parseFloat(rowItem.price)) *
                (marginValue + 1)
              : parseFloat(rowItem.retail) -
                parseFloat(rowItem.price) * (marginValue + 1)
            ).toFixed(2)}
          {marginType === "$" &&
            (includeShipping
              ? parseFloat(rowItem.retail) -
                2.0 -
                parseFloat(rowItem.price) +
                marginValue
              : parseFloat(rowItem.retail) -
                parseFloat(rowItem.price) +
                marginValue
            ).toFixed(2)}
        </td>
      </tr>
    );
  };


  const SummaryRow = () => {
    return (
      <tr className="bg-[#DAF6FF] border-b border-gray-100">
        <td className="p-4">
          <input
            className="w-4 h-4 invisible"
            type="checkbox"
            name=""
            id=""
            checked={checkedAll}
            onChange={handleCheckAll}
          />
        </td>
        <td className="px-4">ALL VARIANTS</td>
        <td className="px-4">
          $
          {Math.min
            .apply(
              Math,
              pricingData.map((i: any) => i.price)
            )
            .toFixed(2)}{" "}
          - $
          {Math.max
            .apply(
              Math,
              pricingData.map((i: any) => i.price)
            )
            .toFixed(2)}
        </td>
        {includeShipping && (
          <td className="px-4">
            $
            {Math.min
              .apply(
                Math,
                pricingData.map((i: any) => i.labor)
              )
              .toFixed(2)}{" "}
            - $
            {Math.max
              .apply(
                Math,
                pricingData.map((i: any) => i.labor)
              )
              .toFixed(2)}
          </td>
        )}
        <td className="px-4">
          $
          {Math.min
            .apply(
              Math,
              pricingData.map((i: any) => i.retail)
            )
            .toFixed(2)}{" "}
          - $
          {Math.max
            .apply(
              Math,
              pricingData.map((i: any) => i.retail)
            )
            .toFixed(2)}
        </td>
        <td className="px-4 bg-[#D8FFE3] text-[#0C8512]">
          $
          {Math.min
            .apply(
              Math,
              pricingData.map((i: any) =>
                includeShipping
                  ? i.retail - i.labor - i.price
                  : i.retail - i.price
              )
            )
            .toFixed(2)}{" "}
          - $
          {Math.max
            .apply(
              Math,
              pricingData.map((i: any) =>
                includeShipping
                  ? i.retail - i.labor - i.price
                  : i.retail - i.price
              )
            )
            .toFixed(2)}
        </td>
      </tr>
    );
  };

  return (
    <Box>
      {/* <div className="flex max-md:flex-col items-stretch justify-between gap-5">
        <div className="w-full max-w-[350px] pr-5 border-r max-md:border-r-0 max-md:border-b pb-3 border-solid border-gray-200">
          <h3 className="mb-3">Set Pricing Rule</h3>
          <p>Select Predefined Pricing Rule or individually Set Price Here</p>
          <br />
          <br />
          <br />
          <br />
          <h3 className="mb-3">Set Shipping Model</h3>
          <p>Select Predefined Shipping Model Here or Create a New Model</p>
        </div>
        <div className="w-full">
          <div className="flex max-md:flex-col items-start justify-between gap-5">
            <div className="max-w-[300px]">
              <label className="block font-bold text-gray-600 mb-2">
                Pricing Model for:{" "}
                <Tooltip text="Select Predefined Pricing Rule or individually Set Price Here" />
              </label>
              <select
                className="block w-full max-w-[328px] p-2 bg-gray-50 rounded-lg border border-gray-300 mb-2"
                name="rule"
                defaultValue={pricingRule}
                onChange={addRule}
              >
                {productMock.availablePricingRules.map((rule: any) => (
                  <option key={rule} value={rule}>
                    {rule}
                  </option>
                ))}
              </select>
              <div>
                {pricingRule.map((rule: any, index: number) => (
                  <Badge blue key={index}>
                    {rule}{" "}
                    <button
                      className="text-[11px] mt-[1px]"
                      onClick={() => deleteRule(rule)}
                    >
                      X
                    </button>
                  </Badge>
                ))}
              </div>
            </div>
            <Button type="secondary">
              <PlusIcon className="w-4 h-4 inline" /> Create New Pricing Rule
            </Button>
          </div>

          <br />
          <br />
          <br />

          <div className="flex max-md:flex-col items-start justify-between gap-5">
            <div className="max-w-[300px]">
              <label className="block font-bold text-gray-600 mb-2">
                Assign Shipping Model:{" "}
                <Tooltip text="Select Predefined Pricing Rule or individually Set Price Here" />
              </label>
              <select
                className="block w-full max-w-[328px] p-2 bg-gray-50 rounded-lg border border-gray-300 mb-2"
                name="rule"
                defaultValue={shippingModel}
                onChange={addModel}
              >
                {productMock.availableShippingModels.map((rule: any) => (
                  <option key={rule} value={rule}>
                    {rule}
                  </option>
                ))}
              </select>
              <div>
                {shippingModel.map((rule: any, index: number) => (
                  <Badge blue key={index}>
                    {rule}{" "}
                    <button
                      className="text-[11px] mt-[1px]"
                      onClick={() => deleteModel(rule)}
                    >
                      X
                    </button>
                  </Badge>
                ))}
              </div>
            </div>
            <Button type="secondary">
              <PlusIcon className="w-4 h-4 inline" /> Create New Shipping Model
            </Button>
          </div>
        </div>
      </div> */}

      <ProductPricingTable
        tableTitle="Product Pricing Table"
        tableDesc="Customers won’t pay for shipping—we’ll charge you for it instead. Shipping costs will automatically be included in your retail price."
        headers={headers}
        data={pricingData}
        summaryRow={<SummaryRow />}
        row={PricingTableRow}
        includeShipping={includeShipping}
        handleIncludeShipping={handleIncludeShipping}
        handleMargin={handleMargin}
        handleCheckAll={handleCheckAll}
      />
    </Box>
  );
};

export default SetPricingRule;
